import { useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import { getInvoiceActionContext } from "src/api/Billing/Payments"

import { useToast } from "src/hooks/use_toast"

// Mounted only while an action is open, so a modal never sees what the cache held before it opened.
export const useInvoiceActionContext = (invoiceId, { onError }) => {
  const { marinaSlug } = useMarina()
  const showToast = useToast()
  const query = useQuery({
    queryKey: ["invoiceActionContext", marinaSlug, invoiceId],
    queryFn: () => getInvoiceActionContext({ marinaSlug, invoiceId }),
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    // Staff are waiting on the click; a retry's backoff would leave them several seconds with nothing.
    retry: false,
    onError: () => {
      showToast("This invoice's details couldn't be loaded. Try again.", {
        type: "error",
      })
      onError()
    },
  })

  return query.isFetchedAfterMount ? query.data : undefined
}
